<template>
    <div>
        <el-table
            ref="rcs-bundle-table"
            v-loading="loadingBundles"
            :data="bundles"
            class="w-full"
            stripe
        >
          <!-- Information Column -->
            <el-table-column
                prop="sid"
                label="Information"
                width="400"
            >
                <template v-slot="scope">
                    <InformationColumn
                        :row="scope.row"
                        :show-rcs-details="true"
                        :show-messaging-service="true"
                    />
                </template>
            </el-table-column>

            <!-- Status Column -->
            <el-table-column
                label="Status"
                prop="status"
                width="200"
            >
                <template v-slot="scope">
                    <StatusColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Countries Column -->
            <el-table-column
                label="Countries"
                prop="countries"
                width="450"
            >
                <template v-slot="scope">
                    <div v-if="scope.row.countries && scope.row.countries.length">
                        <div
                          v-for="country in scope.row.countries"
                          :key="country.registration_sid"
                          class="mb-2"
                        >
                            <!-- Country + flag -->
                            <div class="font-weight-bold">
                              <span class="mr-1">{{ getFlag(country.country) }}</span>
                              {{ country.country }}
                            </div>

                            <!-- registration sid -->
                            <div>
                              {{ country.registration_sid }}
                            </div>

                            <!-- carriers -->
                            <div class="small">
                              <div v-for="carrier in country.carriers" :key="carrier.name">
                                • {{ carrier.name }} ({{ carrier.status }})
                              </div>
                            </div>
                        </div>
                    </div>

                    <span v-else class="text-muted">No countries</span>
              </template>
            </el-table-column>

            <!-- Assigned Line Column -->
            <el-table-column label="Assigned Line" width="200">
                <template v-slot="scope">
                    <span v-if="scope.row.campaign">
                        {{ scope.row.campaign.name }}
                    </span>
                    <span v-else class="text-muted">Not assigned</span>
                </template>
            </el-table-column>

            <!-- Created At Column -->
            <el-table-column
                label="Created At"
                width="250"
            >
                <template v-slot="scope">
                    <TimestampsColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Actions Column -->
            <el-table-column
                label="Actions"
            >
                <template v-slot="scope">
                    <el-tooltip
                        :disabled="!(scope.row.messaging_service_id && scope.row.campaign_id)"
                        content="This RCS sender is already assigned to a line."
                        placement="top"
                    >
                        <span>
                            <el-button
                                type="warning"
                                size="small"
                                :disabled="!!(scope.row.messaging_service_id && scope.row.campaign_id)"
                                @click="handleManageLines(scope.row)"
                            >
                                Manage Lines
                            </el-button>
                        </span>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import TimestampsColumn from '../columns/timestamps-column'
import StatusColumn from '../columns/status-column'
import InformationColumn from '../columns/information-column.vue'

export default {
    name: 'RcsBundleTable',
    components: {
        InformationColumn,
        TimestampsColumn,
        StatusColumn
    },
    props: {
        bundles: {
            type: Array,
            required: true
        },
        loadingBundles: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        handleManageLines(bundle) {
            this.$emit('manage-lines', bundle)
        },
        getFlag(countryCode) {
            if (!countryCode) {
              return null
            }

            return countryCode
                .toUpperCase()
                .replace(/./g, (char) =>
                    String.fromCodePoint(127397 + char.charCodeAt())
                )
        }
    }
}
</script>
